export const DIRECT_STOP_VALUE = 0;
